(function () {
    // サーバーレンダリングなど document のない環境では何もしない
    if (typeof document === 'undefined') {
        return;
    }

    // タブブロック初期化関数
    function initTabs(root) {

        // header(タブ) とパネル(コンテンツ)取得
        var headerStart = root.querySelector('.lpcb-tabs__header-start');
        var panelsWrap = root.querySelector('.lpcb-tabs__panels');
        if (!headerStart || !panelsWrap) {
            return;
        }

        // 全てのタブとパネルをNodeListとして取得
        var buttons = headerStart.querySelectorAll('.lpcb-tabs__tab');
        var panels = [];
        var candidates = panelsWrap.querySelectorAll('.lpcb-tab__panel');
        for (var p = 0; p < candidates.length; p++) {
            // ネストされた Tabs 内の panel を拾わない（この panelsWrap 直下のものだけ）
            if (candidates[p].closest('.lpcb-tabs__panels') === panelsWrap) {
                panels.push(candidates[p]);
            }
        }
        if (!buttons.length || !panels.length) {
            return;
        }

        // 指定タブ(index)をアクティブにする内部関数
        function activate(index) {
            // 全てのタブを回す
            for (var i = 0; i < buttons.length; i++) {
                var isActive = i === index; // 指定タブの場合はtrueに
                var btn = buttons[i];
                var panel = panels[i];
                if (!panel) { continue; } // パネルが無い場合（念の為）

                // true: そのタブに is-active クラスを仕込む, false: is-activeを消す
                btn.classList.toggle('is-active', isActive);
                btn.setAttribute('aria-selected', isActive ? 'true' : 'false');

                // アクティブの場合は表示
                if (isActive) {
                    panel.removeAttribute('hidden');
                    panel.style.display = '';
                // 非アクティブは非表示
                } else {
                    panel.setAttribute('hidden', 'hidden');
                    panel.style.display = 'none';
                }
            }
            // ルート要素にも現在のアクティブインデックスを data 属性として記録
            root.setAttribute('data-active-index', String(index));
        }

        // 初期表示するタブを取得
        var activeAttr = root.getAttribute('data-active-index');
        var initialIndex = parseInt(activeAttr || '0', 10);
        if (isNaN(initialIndex) || initialIndex < 0 || initialIndex >= buttons.length) {
            initialIndex = 0;
        }

        // そのタブをアクティブにする
        activate(initialIndex);

        // 全てのボタンにクリックイベントを仕込んで、クリックされたらactivate(idx)を呼ぶようにする
        for (var i = 0; i < buttons.length; i++) {
            (function (idx) {
                buttons[idx].addEventListener('click', function () {
                    activate(idx);
                });
            })(i);
        }
    }

    // ページ内に存在する全ての .lpcb-tabs に対して 順番に初期化 initTabs を実行
    function initAll() {
        var roots = document.querySelectorAll('.lpcb-tabs');
        for (var i = 0; i < roots.length; i++) {
            initTabs(roots[i]);
        }
    }

    // DOM 構築前なら DOMContentLoaded 後に初期化、すでに構築済みなら即初期
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAll);
    } else {
        initAll();
    }
})();
